import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.split";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
var TYPE_NAME = ['number', 'boolean', 'string', 'array', 'object', 'function', 'date', 'htmlelement', 'jquery', 'jqueryevent', 'any'];

var getClassName = function getClassName(name) {
  var replacedName = name.toLowerCase();
  return TYPE_NAME.indexOf(replacedName) > -1 ? replacedName : 'etc';
};

var Types =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Types, _React$Component);

  function Types() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Types.prototype;

  _proto.makeType = function makeType(name, index) {
    var className = getClassName(name);
    return React.createElement("span", {
      key: "type-" + index,
      className: "type " + className
    }, name);
  };

  _proto.makeTypeApplicationName = function makeTypeApplicationName(name, index) {
    var _this = this;

    var splited = name.split('.');
    var matrix = splited.length > 2;
    var prefix = splited[0]; // 'Array' or 'Object'

    var types = splited[1];
    var subPrefix;

    if (matrix) {
      subPrefix = splited[1];
      types = splited[2];
    }

    var joinedName = types.split('|').map(function (item, idx) {
      return _this.makeType(item, idx);
    });
    var component;

    if (matrix) {
      component = React.createElement("span", {
        className: "type",
        key: "type-" + index
      }, prefix, ".<", subPrefix, ".<", joinedName, ">>");
    } else {
      component = React.createElement("span", {
        className: "type",
        key: "type-" + index
      }, prefix, ".<", joinedName, ">");
    }

    return component;
  };

  _proto.makeOptionalType = function makeOptionalType(types) {
    var _this$props = this.props,
        defaultVal = _this$props.defaultVal,
        data = _this$props.data;
    var prefix = data.prefix,
        isOptional = data.isOptional;
    var defaultValue = defaultVal ? " = " + this.props.defaultVal : '';
    var wrapperComponent;

    if (isOptional) {
      wrapperComponent = React.createElement("span", {
        className: "types-wrapper"
      }, "[ ", prefix, types, " ]", defaultValue);
    } else {
      wrapperComponent = React.createElement("span", {
        className: "types-wrapper"
      }, prefix, types, defaultValue);
    }

    return wrapperComponent;
  };

  _proto.render = function render() {
    var _this2 = this;

    var names = this.props.data.names;

    if (names) {
      var types = names.map(function (name, index) {
        if (name.indexOf('.') > -1) {
          return _this2.makeTypeApplicationName(name);
        }

        return _this2.makeType(name, index);
      });
      return React.createElement("p", {
        className: "types"
      }, this.makeOptionalType(types));
    }

    return null;
  };

  return Types;
}(React.Component);

export default Types;